import React from 'react';

import { Grid, Container } from '@material-ui/core/';

import Label from '../../../components/Label';
import { config } from '../../../config';

import {
    ContainerBox,
    Content,
    Row,
    Align,
} from './styles';

const Details = ({ data }) => {
    return (
        <ContainerBox>
            <Content>
                <Label
                    size='medium'
                    color='dark'
                    align='left'
                    weight='700'
                >
                    {data.name}
                </Label>
                <Container className="container" maxWidth="md">
                    <Row>
                        <Container className="container" maxWidth="md">
                        <Grid
                            container
                            spacing={2}
                            direction="row"
                            justify="flex-start"
                            alignItems="flex-start"
                        >
                            <Grid item xs={12} sm={6} md={8}>
                                <Content>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                    >
                                        {data.description}
                                    </Label>

                                    <Align>
                                        <Label
                                            size='pico'
                                            color='dark'
                                            align='left'
                                            weight='700'
                                            padding='10px 5px'
                                        >Endereço:</Label>
                                        <Label
                                            size='pico'
                                            color='dark'
                                            align='left'
                                            padding='10px 5px'
                                        >
                                            {data.address}
                                        </Label>
                                    </Align>

                                    <Align>
                                        <Label
                                            size='pico'
                                            color='dark'
                                            align='left'
                                            weight='700'
                                            padding='10px 5px'
                                        >Cep:</Label>
                                        <Label
                                            size='pico'
                                            color='dark'
                                            align='left'
                                            padding='10px 5px'
                                        >
                                            {data.cep}
                                        </Label>
                                    </Align>

                                    <Align>
                                        <Label
                                            size='pico'
                                            color='dark'
                                            align='left'
                                            weight='700'
                                            padding='10px 5px'
                                        >Data:</Label>
                                        <Label
                                            size='pico'
                                            color='dark'
                                            align='left'
                                            padding='10px 5px'
                                        >
                                            {new Date(data.start_at).toLocaleDateString()}
                                        </Label>
                                    </Align>
                                </Content>
                            </Grid>
                            {false && <Grid item xs={12} sm={6} md={4}>
                                <Content>
                                    <Label
                                        size='nano'
                                        color='dark'
                                        align='left'
                                    >
                                        Lotação
                                    </Label>
                                    <Align>
                                        <Label
                                            size='nano'
                                            color='dark'
                                            align='left'
                                            weight='700'
                                            padding='10px 5px'
                                        >Lotação Dia 17:</Label>
                                        <Label
                                            size='nano'
                                            color='dark'
                                            align='left'
                                            padding='10px 5px'
                                        >
                                            {data.day_1_counter}
                                        </Label>
                                    </Align>

                                    <Align>
                                        <Label
                                            size='nano'
                                            color='dark'
                                            align='left'
                                            weight='700'
                                            padding='10px 5px'
                                        >Lotação dia 18:</Label>
                                        <Label
                                            size='nano'
                                            color='dark'
                                            align='left'
                                            padding='10px 5px'
                                        >
                                            {data.day_2_counter}
                                        </Label>
                                    </Align>

                                    <Align>
                                        <Label
                                            size='nano'
                                            color='dark'
                                            align='left'
                                            weight='700'
                                            padding='10px 5px'
                                        >Lotação dia 19:</Label>
                                        <Label
                                            size='nano'
                                            color='dark'
                                            align='left'
                                            padding='10px 5px'
                                        >
                                            {data.day_3_counter}
                                        </Label>
                                    </Align>

                                    <Align>
                                        <Label
                                            size='nano'
                                            color='dark'
                                            align='left'
                                            weight='700'
                                            padding='10px 5px'
                                        >Lotação Total:</Label>
                                        <Label
                                            size='nano'
                                            color='dark'
                                            align='left'
                                            padding='10px 5px'
                                        >
                                            {data.day_1_counter+data.day_2_counter+data.day_3_counter}
                                        </Label>
                                    </Align>
                                </Content>
                                {/* <img
                                    style={{height: '200px', width: '200px',}}
                                    src={`${config.QRCODE_HOST}/?size=200x200&data=${config.FRONT_HOST}/subscription/${data.id}`}
                                    alt="qrcode"
                                /> */}
                            </Grid>}
                        </Grid>
                    </Container>
                </Row>
                </Container>
            </Content>
        </ContainerBox>
    )
}

export default Details;
